module.exports = __webpack_public_path__ + "img/essentials-for-living.50d622d.png";